import { ReactElement } from 'react';

import { Stack, Typography } from '@mui/material';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import DownloadingIcon from '@mui/icons-material/Downloading';
import { DashboardIcon } from '../../assets/svgs/DashboardIcon';
import { UsersIcon } from '../../assets/svgs/UsersIcon';
import { CubsIcon } from '../../assets/svgs/CubsIcon';
import { ProfileInfo } from './ProfileInfo';
import { useLocation } from 'react-router-dom';
import { Link } from '../global/Link';
import { ClientIcon } from '../../assets/svgs/ClientIcon';
import { CategoryIcon } from '../../assets/svgs/CategoryIcon';
import AssetRegisterLogo from '../../assets/images/logo.svg';
import { TagIcon } from '../../assets/svgs/TagIcon';

type SidebarMenuItemType = {
  name: string;
  icon: ReactElement;
  selectedIcon: ReactElement;
  link: string;
};

const sidebarMenuItems: SidebarMenuItemType[] = [
  {
    name: 'Dashboard',
    icon: <DashboardIcon color="#4B5851" />,
    selectedIcon: <DashboardIcon color="#FFFFFF" />,
    link: '/',
  },
  {
    name: 'API',
    icon: <ClientIcon color="#4B5851" />,
    selectedIcon: <ClientIcon color="#FFFFFF" />,
    link: '/api',
  },
  {
    name: 'Test Bed',
    icon: <CategoryIcon color="#4B5851" />,
    selectedIcon: <CategoryIcon color="#FFFFFF" />,
    link: '/test',
  },
  {
    name: 'Reports',
    icon: <UsersIcon color="#4B5851" />,
    selectedIcon: <UsersIcon color="#FFFFFF" />,
    link: '/reports',
  },
  {
    name: 'Invoices',
    icon: <CubsIcon color="#4B5851" />,
    selectedIcon: <CubsIcon color="#FFFFFF" />,
    link: '/invoices',
  },
  {
    name: 'Corrections',
    icon: <TagIcon color="#4B5851" />,
    selectedIcon: <TagIcon color="#FFFFFF" />,
    link: '/corrections',
  },
  {
    name: 'Session Data',
    icon: <DownloadingIcon sx={{ fontSize: '1.25rem', color: '#4B5851' }} />,
    selectedIcon: (
      <DownloadingIcon sx={{ fontSize: '1.25rem', color: '#FFFFFF' }} />
    ),
    link: '/session_data',
  },
  {
    name: 'Documentation',
    icon: <FolderCopyIcon sx={{ fontSize: '1.25rem', color: '#4B5851' }} />,
    selectedIcon: (
      <FolderCopyIcon sx={{ fontSize: '1.25rem', color: '#FFFFFF' }} />
    ),
    link: '/documentation',
  },
  {
    name: 'Integrations',
    icon: <IntegrationInstructionsIcon sx={{ color: '#4B5851' }} />,
    selectedIcon: <IntegrationInstructionsIcon sx={{ color: '#FFFFFF' }} />,
    link: '/integrations',
  },
];

export const Sidebar = () => {
  const location = useLocation();

  return (
    <Stack
      className="sidebar"
      width="250px"
      minWidth="250px"
      height="100vh"
      borderRight="1px solid #DCDCE0">
      <Stack mt={4} alignItems="center" justifyContent="center">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <img src={AssetRegisterLogo} height={60} />
        </Link>
      </Stack>
      <Stack mt={2}>
        <ProfileInfo />
        {sidebarMenuItems.map((item: SidebarMenuItemType, index: number) => {
          const isSelected =
            item.link === '/'
              ? item.link === location.pathname
              : location.pathname.startsWith(item.link);

          return (
            <Link
              className="sidebar-item"
              key={index}
              to={item.link}
              style={{
                cursor: 'pointer',
                textDecoration: 'none',
                background: isSelected ? '#3E4049' : '#FFFFFF',
                display: 'block',
                color: isSelected ? '#FFFFFF' : '#4B5851',
                padding: '12px 16px',
              }}>
              <Stack flexDirection="row" alignItems="center">
                <span style={{ minWidth: '25px', textAlign: 'center' }}>
                  {isSelected ? item.selectedIcon : item.icon}
                </span>
                <Typography color={isSelected ? '#FFFFFF' : '#4B5851'} ml={1}>
                  {item.name}
                </Typography>
              </Stack>
            </Link>
          );
        })}
      </Stack>
    </Stack>
  );
};
